import React from 'react';
import './Footer.css';
import { FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import {
  FaLinkedin,
  FaInstagram,
  FaFacebook,
  FaXTwitter,
  FaYoutube,
} from 'react-icons/fa6';

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const Footer = ({ openEnroll }) => (
  <footer className="footer">
    {/* ---------- Top Grid ---------- */}
    <div className="footer-main">
      {/* Contact */}
      <div className="footer-section">
        <img src="/footer/Robokalam Logo Real header 1.png" alt="Robokalam Logo" className="footer-logo" />
        <h4>Reach Us</h4>

        {/* WhatsApp block */}
        <div className="contact-row">
          <FaWhatsapp className="icon whatsapp" />
          <div className="multi-lines">
            <p style={{ margin: 0 }}>
              <a
                href="https://wa.me/919666287717"
                target="_blank"
                rel="noreferrer"
                style={{ color: 'white', textDecoration: 'none' }}
              >
                +91 966628 7717
              </a>
            </p>
            <p style={{ margin: 0 }}>
              <a
                href="https://wa.me/919666287747"
                target="_blank"
                rel="noreferrer"
                style={{ color: 'white', textDecoration: 'none' }}
              >
                +91 966628 7747
              </a>
            </p>
          </div>
        </div>


        {/* Email block */}
        <div className="contact-row">
          <FaEnvelope className="icon" />
          <a href="mailto:info@robokalam.in" className="plain-link">
            info@robokalam.in
          </a>
        </div>

        <p className="copyright">
          © 2025 Robokalam Technologies Pvt. Ltd. All rights reserved.
        </p>
      </div>

      {/* Quick Links */}
      <div className="footer-section">
        <h4>Quick Links</h4>
        <div className="quick-links">
          <a href="/">Home</a>
          <a
            href="/#hire"
            onClick={(e) => { e.preventDefault(); openEnroll(); }}
            style={{ cursor: 'pointer' }}
          >
            Hire With Us
          </a>
          <a
            href="/#contact"
            onClick={(e) => { e.preventDefault(); openEnroll(); }}
            style={{ cursor: 'pointer' }}
          >
            Contact Us
          </a>
          <a
            href="/#what-we-offer"
            onClick={(e) => { e.preventDefault(); scrollToSection('what-we-offer'); }}
            style={{ cursor: 'pointer' }}
          >
            About Us
          </a>
          <a
            href="/#testimonials"
            onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); }}
            style={{ cursor: 'pointer' }}
          >
            Reviews
          </a>
          <a
            href="/#mentor-community"
            onClick={(e) => { e.preventDefault(); scrollToSection('mentor-community'); }}
            style={{ cursor: 'pointer' }}
          >
            Mentorship
          </a>
        </div>
      </div>

      {/* Location */}
      {/* <div className="footer-section">
        <h4>Location</h4>
        <div className="contact-row">
          <FaMapMarkerAlt className="icon" />
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=Plot+No+1%2FC,+Sy+No+83%2F1,+Raidurgam,+Knowledge+City+Rd,+Panmaktha,+Hyderabad,+Serilingampalle+(M),+Telangana+500081"
            target="_blank"
            rel="noreferrer"
            className="plain-link"
            style={{ color: 'white', textDecoration: 'none' }}
          >
            Plot No 1/C, Sy No 83/1, Raidurgam, Knowledge City Rd,<br />
            Panmaktha, Hyderabad, Serilingampalle (M), Telangana 500081
          </a>
        </div>
      </div> */}

      <div className="footer-section">
        <h4>Location</h4>

        {/* 👇 Embedded Map Preview (Live View) */}
        <div className="footer-map-preview">
          <iframe
            title="T-Hub Robokalam Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.599918185365!2d78.3769245!3d17.4279923!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93bd18410b0f%3A0x8d7e3fea891858ce!2sT-Hub!5e0!3m2!1sen!2sin!4v1720512301727!5m2!1sen!2sin"
            width="100%"
            height="220"
            style={{
              border: 0,
              borderRadius: "10px",
              marginBottom: "12px"
            }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />

        </div>

        {/* 👇 Your original address block remains unchanged */}
        <div className="contact-row">
          <FaMapMarkerAlt className="icon" />
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=Plot+No+1%2FC,+Sy+No+83%2F1,+Raidurgam,+Knowledge+City+Rd,+Panmaktha,+Hyderabad,+Serilingampalle+(M),+Telangana+500081"
            target="_blank"
            rel="noreferrer"
            className="plain-link"
            style={{ color: 'white', textDecoration: 'none' }}
          >
            Plot No 1/C, Sy No 83/1, Raidurgam, Knowledge City Rd,<br />
            Panmaktha, Hyderabad, Serilingampalle (M), Telangana 500081
          </a>
        </div>
      </div>

    </div>

    <hr />

    {/* ---------- Bottom Row ---------- */}
    <div className="footer-bottom">
      <div className="social-icons">
        <a href="https://www.linkedin.com/company/robokalam" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="linkedin">
          <FaLinkedin />
        </a>
        <a href="https://www.instagram.com/robokalam" target="_blank" rel="noreferrer" aria-label="Instagram" className="instagram">
          <FaInstagram />
        </a>
        <a href="https://www.facebook.com/robokalam" target="_blank" rel="noreferrer" aria-label="Facebook" className="facebook">
          <FaFacebook />
        </a>
        <a href="https://twitter.com/robokalam" target="_blank" rel="noreferrer" aria-label="Twitter" className="twitter">
          <FaXTwitter />
        </a>
        <a href="https://www.youtube.com/@robokalam" target="_blank" rel="noreferrer" aria-label="YouTube" className="youtube">
          <FaYoutube />
        </a>
      </div>

      <div className="footer-policies">
        <a href="https://learn.robokalam.com/privacypolicy" target="_blank" rel="noreferrer">Privacy Policy</a>
        <a href="https://learn.robokalam.com/termsofuse" target="_blank" rel="noreferrer">Terms & Conditions</a>
        <a href="https://learn.robokalam.com/refundpolicy" target="_blank" rel="noreferrer">Refund policy</a>
        <a
          href="/#contact"
          onClick={(e) => { e.preventDefault(); openEnroll(); }}
          style={{ cursor: 'pointer' }}
        >
          Contact Us
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
